import react, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { MdSearch } from 'react-icons/md'
import styled from 'styled-components'
import { JobCategory1 } from '../../models/JobCategory1'
import { JobCategory2 } from '../../models/JobCategory2'
import { JobSimple } from '../../models/JobSimple'
import { RootState, useAppDispatch, useAppSelector } from '../../store'
import {
  asyncGetInventories,
  asyncGetJobCategories,
  setInInventory,
  setOutInventory,
} from '../../store/mainSlice'
import { registerInventory, unregisterInventory } from './CommonApi'
import Job from './Job'
import { UserRole } from '../../models/User'

type CategoryProps = {
  current?: string
}

function JobSearch() {
  const [categoryIndex1, setCategoryIndex1] = useState(0)
  const [categoryIndex2, setCategoryIndex2] = useState(0)
  const [jobCategories2, setJobCategories2] = useState<JobCategory2[]>([])
  const [jobs, setJobs] = useState<JobSimple[]>([])
  const [isCategory, setIsCategory] = useState<boolean>(true)
  const [searchKeyword, setSearchKeyword] = useState<string>('')

  const me = useAppSelector((state: RootState) => state.user.me)

  const jobCategories1: JobCategory1[] = useAppSelector(
    (state: RootState) => state.main.jobCategories1
  )
  const allJobs: JobSimple[] = useAppSelector(
    (state: RootState) => state.main.jobs
  )
  const dispatch = useAppDispatch()

  const getCategory2 = () => {
    if (
      jobCategories1.length > 0 &&
      jobCategories1[0].categories2 &&
      jobCategories1[0].categories2.length > 0
    ) {
      setJobCategories2(jobCategories1[0].categories2)
      setJobs(jobCategories1[0].categories2[0].jobs)
    } else {
      console.log('not found category')
    }
  }

  const initialLoadJobCategories = async () => {
    setCategoryIndex1(0)

    if (jobCategories1.length === 0) {
      await dispatch(asyncGetJobCategories())
    }
  }

  const reducerInventories = useAppSelector(
    (state: RootState) => state.main.inventories
  )
  useEffect(() => {
    if (reducerInventories && reducerInventories.length === 0) {
      dispatch(asyncGetInventories())
    }
  }, [])

  // 시작시 카테고리를 로딩한다
  useEffect(() => {
    initialLoadJobCategories()
  }, [])

  // initialLoadJobCategories 이 완료되었을때
  useEffect(() => {
    getCategory2()
  }, [jobCategories1])

  // 분류1 클릭
  useEffect(() => {
    if (categoryIndex1 < 0 || categoryIndex1 >= jobCategories1.length) {
      return
    }
    setCategoryIndex2(0)
    setJobCategories2(jobCategories1[categoryIndex1].categories2)
    setJobs(jobCategories1[categoryIndex1].categories2[0].jobs)
  }, [categoryIndex1])

  // 분류2 클릭
  useEffect(() => {
    if (categoryIndex2 < 0 || categoryIndex2 >= jobCategories2.length) {
      return
    }
    setJobs(jobCategories2[categoryIndex2].jobs)
  }, [categoryIndex2])

  // 키워드 검색
  const search = (e: React.FormEvent<HTMLInputElement>) => {
    const keyword = (e.target as HTMLInputElement).value
    setSearchKeyword(keyword)
    setJobs(allJobs.filter((job) => job.name.includes(keyword)))

    setIsCategory(false)
  }

  const handleRegisterInventory = async (jobId: number, isAdd: boolean) => {
    let success = false
    if (isAdd) {
      success = await registerInventory(jobId, me.id, dispatch)
    } else {
      if (confirm('인벤토리에서 제거하시겠습니까?') === false) {
        return
      }
      success = await unregisterInventory(jobId, me.id, dispatch)
    }

    if (success) {
      setJobs(
        jobs.map((job) =>
          job.id === jobId ? { ...job, isInInventory: isAdd } : job
        )
      )
    }
  }

  return (
    <Container>
      <SearchBar>
        <MdSearch className="icon" />
        <input
          type="text"
          placeholder="검색할 직업명을 입력하세요"
          onChange={(e) => search(e)}
        />
        <button>검색하기</button>
      </SearchBar>
      <Categories>
        <Category>
          <div className="title">분류1</div>
          <div className="list">
            {jobCategories1 &&
              jobCategories1.map((category1: JobCategory1, index: number) => {
                return (
                  <Item
                    key={index}
                    current={index === categoryIndex1 ? 'current' : ''}
                    onClick={() => {
                      setCategoryIndex1(index)
                      setIsCategory(true)
                    }}
                  >
                    {category1.name}
                  </Item>
                )
              })}
          </div>
        </Category>
        <Category>
          <div className="title">분류2</div>
          <div className="list">
            {jobCategories2 &&
              jobCategories2.map((category2: JobCategory2, index: number) => {
                return (
                  <Item
                    key={index}
                    current={index === categoryIndex2 ? 'current' : ''}
                    onClick={() => {
                      setCategoryIndex2(index)
                      setIsCategory(true)
                    }}
                  >
                    {category2.name}
                  </Item>
                )
              })}
          </div>
        </Category>
      </Categories>
      <ResultType>
        {isCategory ? (
          <>
            <div>카테고리</div>
            <div>
              {jobCategories1[categoryIndex1] &&
                jobCategories1[categoryIndex1].name}
            </div>
            <div> &gt; </div>
            <div>
              {jobCategories1[categoryIndex1] &&
                jobCategories1[categoryIndex1].categories2 &&
                jobCategories1[categoryIndex1].categories2[categoryIndex2] &&
                jobCategories1[categoryIndex1].categories2[categoryIndex2].name}
            </div>
          </>
        ) : (
          <>
            <div>검색 키워드</div>
            <div className="searchKeyword">{searchKeyword}</div>
          </>
        )}
      </ResultType>
      <Result>
        {jobs &&
          jobs.map((job: JobSimple, index: number) => {
            return me.userRole === UserRole.MENTOR ||
              me.userRole === UserRole.ADMIN ? (
              <Job
                key={index}
                id={job.id}
                image={job.photo}
                name={job.name}
                description={job.overview}
              />
            ) : (
              <Job
                key={index}
                id={job.id}
                image={job.photo}
                name={job.name}
                description={job.overview}
                isInInventory={job.isInInventory}
                onChangeToInventory={handleRegisterInventory}
              />
            )
          })}
      </Result>
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
  margin-bottom: 1rem;
`
const SearchBar = styled.div`
  display: flex;
  column-gap: 10px;
  margin-left: -25px;
  margin-bottom: 10px;

  .icon {
    position: relative;
    left: 35px;
    top: 7px;
  }
  input {
    padding: 5px 10px 5px 25px;
  }
  button {
    padding-top: 0px;
  }
`
const Result = styled.div`
  margin-bottom: 10px;
  border: 1px solid #eee;
  padding: 15px;
  /* display: none; */
`

const Categories = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`
const Category = styled.div`
  border-left: 1px solid #eee;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 10px;
  font-size: 0.95rem;

  &:last-child {
    border-right: 1px solid #eee;
  }

  .title {
    padding: 10px 0 0;
    font-weight: 400;
    border-bottom: 2px solid #eee;
    margin-bottom: 10px;
  }
`

const Item = styled.div`
  padding: 10px 0;
  cursor: pointer;

  &:hover {
    background-color: ${(props: CategoryProps) =>
      props.current === 'current'
        ? 'var(--point-color3)'
        : 'var(--point-color5)'};
    color: ${(props: CategoryProps) =>
      props.current === 'current' ? 'white' : '#555'};
  }

  background-color: ${(props: CategoryProps) =>
    props.current === 'current'
      ? 'var(--point-color3)'
      : 'var(--point-color5)'};
  color: ${(props: CategoryProps) =>
    props.current === 'current' ? 'white' : '#555'};
`

const ResultType = styled.div`
  display: flex;
  column-gap: 10px;
  padding: 10px 5px;
  color: #555;
  align-items: baseline;

  div:first-child {
    padding: 5px;
    background-color: tomato;
    color: #eee;
    text-decoration: none;
  }
  div.searchKeyword {
    text-decoration: underline;
  }
`

const Badge = styled.span``

export default JobSearch
